import React from "react";
import { Drawer, Box, useMediaQuery, Button } from "@mui/material";
import CascadeLevelDrawer from "./CascadeLevelDrawer";
import { DrawerItem } from "./ItemsDrawer";
import { ChevronRight } from '@mui/icons-material';
import { useTranslation } from "react-i18next";

interface CascadeDrawerProps {
    open: boolean;
    handleDrawerState: () => void,
    level: number,
    setLevel: React.Dispatch<React.SetStateAction<number>>,
    historico: DrawerItem[] | [],
    setHistorico: React.Dispatch<React.SetStateAction<DrawerItem[] | []>>,
}

const CascadeDrawer: React.FC<CascadeDrawerProps> = ({ open, handleDrawerState, level, setLevel, historico, setHistorico }) => {

    const changeDrawerOrientation = useMediaQuery('(max-width: 769px)');

    const { t } = useTranslation();

    return (
        <Drawer
            anchor="left"
            open={open}
            onClose={() => handleDrawerState()}
            variant="temporary"
            PaperProps={{
                sx: {
                    display: "flex",
                    flexDirection: changeDrawerOrientation ? 'column' : 'row',
                    transition: "width 0.7s ease", // Animação para transição suave
                    backgroundColor: '#000000',
                    paddingTop: { xs: '24%', sm: '12%', md: '10%', lg: '8%', xl: '6%' },
                    width: level === 2 || changeDrawerOrientation ? "100%" : undefined
                },
            }}>

            {changeDrawerOrientation &&
                <Box sx={{ backgroundColor: '#000000' }}>
                    <Button
                        sx={historicoBtnStyle}
                        disableRipple
                        onClick={() => { setHistorico([]); setLevel(0); }}>
                        HOME
                    </Button>
                    {historico[0] &&
                        <>
                            <ChevronRight sx={{ color: 'white' }} />
                            <Button
                                sx={historicoBtnStyle}
                                disableRipple
                                onClick={() => {
                                    if (historico.length > 1) {
                                        setHistorico((prevHistorico) => prevHistorico.slice(0, -1));
                                    }
                                    setLevel(1);
                                }}
                            >
                                {t(historico[0].label)}
                            </Button>
                        </>}

                    {historico[1] &&
                        <>
                            <ChevronRight sx={{ color: 'white' }} />
                            <Button
                                sx={historicoBtnStyle}
                                disableRipple
                            >
                                {t(historico[1].label)}
                            </Button>
                        </>}
                </Box>
            }

            {Array.from({ length: level + 1 }).map((_, index) => (
                <Box
                    key={index}
                    sx={{
                        display: changeDrawerOrientation && index !== level ? "none" : null,
                        flexDirection: "row",
                        alignItems: "start",
                        paddingLeft: index === 0 ? `calc((100vw - 1140px) / 2)` : 0
                    }}>
                    <CascadeLevelDrawer level={index} setLevel={setLevel} historico={historico} setHistorico={setHistorico} handleDrawerState={handleDrawerState} />
                </Box>
            ))}

        </Drawer>
    );
};

const historicoBtnStyle = {
    color: 'white',
    fontSize: 12,
    marginBottom: 1.5,
    fontFamily: 'Roboto, Arial, sans-serif',
    fontWeight: 'bold',
    backgroundColor: "transparent",
    "&:hover": {
        backgroundColor: "inherit",
    },
}

export default CascadeDrawer;
